// Direct import required — index.ts uses `export * from` which doesn't re-export default exports
import httpClient from '@yard/app/http-client/http-client'

export interface DGSegregationRuleDto {
  id: string
  imoClass1: string
  imoClass2: string
  distance: number
  isProhibited: boolean
}

export interface UpsertDGSegregationRulesDto {
  rules: Array<{ imoClass1: string; imoClass2: string; distance: number; isProhibited: boolean }>
}

export interface ImoClassStackingRuleDto {
  id: string
  imoClass: string
  maxTiers: number
  isStackingOnTopAllowed: boolean
}

export interface UpdateDGStackingRuleDto {
  maxTiers: number
  isStackingOnTopAllowed: boolean
}

export interface ContainerLengthBayMappingDto {
  id: string
  length: number
  bayCount: number
  isStandard: boolean
}

export interface CreateContainerLengthBayMappingDto {
  length: number
  bayCount: number
}

export interface UpdateContainerLengthBayMappingDto {
  length: number
  bayCount: number
}

export class DGSegregationRulesApi {
  async getAll(): Promise<DGSegregationRuleDto[]> {
    const { data } = await httpClient.get<DGSegregationRuleDto[]>('/yard/api/DGSegregationRules')
    return data
  }

  async upsert(dto: UpsertDGSegregationRulesDto): Promise<DGSegregationRuleDto[]> {
    const { data } = await httpClient.put<DGSegregationRuleDto[]>(
      '/yard/api/DGSegregationRules',
      dto,
    )
    return data
  }

  async resetToDefaults(): Promise<DGSegregationRuleDto[]> {
    const { data } = await httpClient.post<DGSegregationRuleDto[]>(
      '/yard/api/DGSegregationRules/ResetToDefaults',
    )
    return data
  }
}

export class DGStackingRulesApi {
  async getAll(): Promise<ImoClassStackingRuleDto[]> {
    const { data } = await httpClient.get<ImoClassStackingRuleDto[]>('/yard/api/DGStackingRules')
    return data
  }

  async update(id: string, dto: UpdateDGStackingRuleDto): Promise<ImoClassStackingRuleDto> {
    const { data } = await httpClient.put<ImoClassStackingRuleDto>(
      `/yard/api/DGStackingRules/${id}`,
      dto,
    )
    return data
  }

  async resetToDefaults(): Promise<ImoClassStackingRuleDto[]> {
    const { data } = await httpClient.post<ImoClassStackingRuleDto[]>(
      '/yard/api/DGStackingRules/ResetToDefaults',
    )
    return data
  }
}

export class ContainerLengthBayMappingsApi {
  async getAll(): Promise<ContainerLengthBayMappingDto[]> {
    const { data } = await httpClient.get<ContainerLengthBayMappingDto[]>(
      '/yard/api/ContainerLengthBayMappings',
    )
    return data
  }

  async create(dto: CreateContainerLengthBayMappingDto): Promise<ContainerLengthBayMappingDto> {
    const { data } = await httpClient.post<ContainerLengthBayMappingDto>(
      '/yard/api/ContainerLengthBayMappings',
      dto,
    )
    return data
  }

  async update(
    id: string,
    dto: UpdateContainerLengthBayMappingDto,
  ): Promise<ContainerLengthBayMappingDto> {
    const { data } = await httpClient.put<ContainerLengthBayMappingDto>(
      `/yard/api/ContainerLengthBayMappings/${id}`,
      dto,
    )
    return data
  }

  async delete(id: string): Promise<string> {
    const { data } = await httpClient.delete<string>(`/yard/api/ContainerLengthBayMappings/${id}`)
    return data
  }
}

export const dgSegregationRulesApi = new DGSegregationRulesApi()
export const dgStackingRulesApi = new DGStackingRulesApi()
export const containerLengthBayMappingsApi = new ContainerLengthBayMappingsApi()
